import { useState } from 'react'
import dayjs from 'dayjs'
import secureLocalStorage from 'react-secure-storage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'

//APP
import { useAccess } from '../../../../../../../context/useAccess'
import { errorAlert } from '../../../../../../../utils/alert'
import { Abastecimento } from '../../../../../../../services/abastecimento/GET'
import { obterLogo } from '../../../../../precisao/mapaFertilidadeResumido/components/tabelaMapas/components/bookFertilidadeResumidoSeparado/components/capa/meta'
import { FiltroAvancado } from '../../../filtro/meta'
import { imprimirPdfAbastecimento } from './meta/gerarPDFAbastecimento'

//COMPONENTS
import ButtonCustom from '../../../../../../../Components/ButtonCustom'
import { localConfig } from '../../../../../../../Configs/localConfig'

//PROPS
interface Props {
    /**Mesma lista que a tabela considera: filtro avançado + busca por nome, sem a paginação */
    abastecimentos: Abastecimento[]
    /**Intervalo do filtro avançado aplicado, vazio quando não há filtro */
    intervalo_datas: FiltroAvancado['intervalo_datas']
    /**Local do filtro avançado aplicado, `null` quando não há filtro */
    local: string | null
    /**A lista completa ainda está carregando: imprimir agora sairia incompleto */
    carregando: boolean
}

export const ImprimirRelatorio: React.FC<Props> = ({ abastecimentos, intervalo_datas, local, carregando }) => {

    const { consultoria, nameCliente } = useAccess()

    const [gerando, setGerando] = useState<boolean>(false)

    function periodo(): string {
        if ((intervalo_datas ?? []).length < 2) return 'Todos'

        const [data_inicial, data_final] = intervalo_datas
        return `${dayjs(data_inicial).format('DD/MM/YYYY')} a ${dayjs(data_final).format('DD/MM/YYYY')}`
    }

    function nomeClienteFile(): string {

        if (!localConfig().codCliente && localConfig()?.conta) {
            return consultoria?.nome
        } else {
            return nameCliente || '??'
        }

    }

    function nomeArquivo(): string {
        const nome_cliente = String(nameCliente ?? '').trim().replace(/\s+/g, '_')
        const data_atual = dayjs().format('DD_MM_YYYY')

        return `relatorio_abastecimento_${nome_cliente}_${data_atual}`
    }

    async function gerarPDF() {
        setGerando(true)
        try {
            const email_usuario_logado: string = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase()

            await imprimirPdfAbastecimento(abastecimentos, {
                logo: obterLogo() ?? consultoria?.logo_url,
                titulo: 'Relatório de Abastecimento',
                nome_arquivo: nomeArquivo(),
                razaoSocial: consultoria?.linha1 ?? '??',
                cliente: nomeClienteFile(),
                periodo: periodo(),
                local: local ?? 'Todos',
                autor: email_usuario_logado ?? '??',
            })
        } catch (error) {
            errorAlert('Falha ao gerar o relatório de abastecimento!')
        } finally {
            setGerando(false)
        }
    }

    return (
        <ButtonCustom
            icon={<FontAwesomeIcon icon={faPrint} />}
            type='secondary'
            onClick={gerarPDF}
            loading={gerando}
            disabled={carregando || abastecimentos.length === 0}
        >
            Imprimir
        </ButtonCustom>
    )
}
